export default function isSymbol(value) {
	return typeof value === 'symbol';
}
